export async function getBlobFromCanvas(canvas) {
  return new Promise(function(resolve) {
    if (!canvas) {
      resolve(null)
    } else {
      canvas.toBlob(function(blob) {
        resolve(blob)
      })
    }
  })
}
